import React, { FC, ReactElement, useContext } from 'react'
import { AgentAdvanced } from '../../../../i18n'
import CLanguageHandler from '../../../NonReact/Languages/LanguageHandler'
import FormRow from '../../Common/Components/FormRow'
import { SelectOptions } from '../../Common/Components/Selects'
import { LanguageContext } from '../../Common/Contexts'
import { CallCentreLicenceTypes } from '../Constants/CallCentreLicenceTypes'
import {
    BROADWORKS_USER_ID_FIELD_NAME,
    CALL_CENTRE_LICENCE_TYPE_FIELD_NAME,
    CISCO_COMMON_ID_FIELD_NAME,
    INTERNAL_NUMBER_FIELD_NAME,
    OID_ON_TEL_SERVER_FIELD_NAME,
    OVERRIDE_MONITORING_FIELD_NAME,
    OWNING_DEPARTMENT_FIELD_NAME,
    OWNING_GROUP_ID_FIELD_NAME,
    TEAMS_USER_ID_FIELD_NAME,
    USER_PRINCIPAL_NAME_FIELD_NAME,
    WEBEX_CALLING_USER_ID_FIELD_NAME
} from '../Constants/FieldNames'
import { ConfigureAgentsContext, ConfigureAgentsContextType } from '../Contexts/ConfigureAgentsContext'
import { OutlinedSelect } from '../../../ReactRouting/Components/Atoms/Inputs/OutlinedSelect'
import { OutlinedTextInput } from '../../../ReactRouting/Components/Atoms/Inputs/OutlinedTextInput'
import { RouterCheckbox } from '../../../ReactRouting/Components/Atoms/Inputs/RouterCheckbox'

export const AgentsAdvancedTab: FC = (): ReactElement => {
    const language: CLanguageHandler = useContext(LanguageContext) as CLanguageHandler
    language.loadBundle(AgentAdvanced.NAME)

    const {
        viewOnly,
        serverTypeConfig: {
            advanced: {
                isCallCentreLicenceType,
                isBroadworksUserID,
                isCiscoCommonID,
                isInternalNumber,
                isOidOnTelServer,
                isOverrideMonitoring,
                isOwningDepartment,
                isOwningGroupID,
                isWebexCallingUserID,
                isTeamsUserID,
                isUserPrincipalName
            }
        }
    }: ConfigureAgentsContextType = useContext(ConfigureAgentsContext)

    const callCentreLicenceTypes: SelectOptions<string> = [
        {
            label: language.get(AgentAdvanced.CallCentreLicenceTypes_None),
            value: CallCentreLicenceTypes.NONE
        },
        {
            label: language.get(AgentAdvanced.CallCentreLicenceTypes_Basic),
            value: CallCentreLicenceTypes.BASIC
        },
        {
            label: language.get(AgentAdvanced.CallCentreLicenceTypes_Standard),
            value: CallCentreLicenceTypes.STANDARD
        },
        {
            label: language.get(AgentAdvanced.CallCentreLicenceTypes_Premium),
            value: CallCentreLicenceTypes.PREMIUM
        }
    ]

    return (
        <div className='ca-advanced-tab tab-area'>
            {isCallCentreLicenceType ? (
                <FormRow>
                    <OutlinedSelect
                        options={callCentreLicenceTypes}
                        label={language.get(AgentAdvanced.AgentAdvanced_Fields_LicenceType)}
                        name={CALL_CENTRE_LICENCE_TYPE_FIELD_NAME}
                        disabled={viewOnly}
                    />
                </FormRow>
            ) : (
                <></>
            )}
            {isInternalNumber ? (
                <FormRow>
                    <OutlinedTextInput
                        labelLeft={language.get(AgentAdvanced.AgentAdvanced_Fields_InternalNumber)}
                        inputName={INTERNAL_NUMBER_FIELD_NAME}
                        disabled={viewOnly}
                    />
                </FormRow>
            ) : (
                <></>
            )}
            {isCiscoCommonID ? (
                <FormRow>
                    <OutlinedTextInput
                        labelLeft={language.get(AgentAdvanced.AgentAdvanced_Fields_CiscoCommonID)}
                        inputName={CISCO_COMMON_ID_FIELD_NAME}
                        disabled={viewOnly}
                    />
                </FormRow>
            ) : (
                <></>
            )}
            {isOverrideMonitoring ? (
                <FormRow>
                    <RouterCheckbox
                        labelLeft={language.get(AgentAdvanced.AgentAdvanced_Fields_OverrideMonitoring)}
                        name={OVERRIDE_MONITORING_FIELD_NAME}
                        disabled={viewOnly}
                    />
                </FormRow>
            ) : (
                <></>
            )}
            {isWebexCallingUserID ? (
                <FormRow>
                    <OutlinedTextInput
                        labelLeft={language.get(AgentAdvanced.AgentAdvanced_Fields_WebexCallingUserID)}
                        inputName={WEBEX_CALLING_USER_ID_FIELD_NAME}
                        disabled={viewOnly}
                    />
                </FormRow>
            ) : (
                <></>
            )}
            {isBroadworksUserID ? (
                <FormRow>
                    <OutlinedTextInput
                        labelLeft={language.get(AgentAdvanced.AgentAdvanced_Fields_BroadworksUserID)}
                        inputName={BROADWORKS_USER_ID_FIELD_NAME}
                        disabled={viewOnly}
                    />
                </FormRow>
            ) : (
                <></>
            )}
            {isTeamsUserID ? (
                <FormRow>
                    <OutlinedTextInput
                        labelLeft={language.get(AgentAdvanced.AgentAdvanced_Fields_TeamsUserID)}
                        inputName={TEAMS_USER_ID_FIELD_NAME}
                        disabled={viewOnly}
                    />
                </FormRow>
            ) : (
                <></>
            )}
            {isUserPrincipalName ? (
                <FormRow>
                    <OutlinedTextInput
                        labelLeft={language.get(AgentAdvanced.AgentAdvanced_Fields_UserPrincipalName)}
                        inputName={USER_PRINCIPAL_NAME_FIELD_NAME}
                        disabled={viewOnly}
                    />
                </FormRow>
            ) : (
                <></>
            )}
            {isOwningGroupID ? (
                <FormRow>
                    <OutlinedTextInput
                        labelLeft={language.get(AgentAdvanced.AgentAdvanced_Fields_OwningGroupID)}
                        inputName={OWNING_GROUP_ID_FIELD_NAME}
                        disabled={viewOnly}
                    />
                </FormRow>
            ) : (
                <></>
            )}
            {isOidOnTelServer ? (
                <FormRow>
                    <OutlinedTextInput
                        labelLeft={language.get(AgentAdvanced.AgentAdvanced_Fields_OIDOnTelephoneServer)}
                        inputName={OID_ON_TEL_SERVER_FIELD_NAME}
                        disabled={viewOnly}
                    />
                </FormRow>
            ) : (
                <></>
            )}
            {isOwningDepartment ? (
                <FormRow>
                    <OutlinedTextInput
                        labelLeft={language.get(AgentAdvanced.AgentAdvanced_Fields_OwningDepartment)}
                        inputName={OWNING_DEPARTMENT_FIELD_NAME}
                        disabled={viewOnly}
                    />
                </FormRow>
            ) : (
                <></>
            )}
        </div>
    )
}
